import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import store from '../store/index';
import router from '../router/index';

// axios配置
axios.defaults.timeout = 100000;
axios.defaults.baseURL = '/api/';
axios.defaults.withCredentials = true;

// ============ AI 对话（sseRequest）复用的具名导出 ============
// 说明：门户 sseRequest.js 用原生 fetch，绕过了下面的 axios 拦截器，
// 因此需要把「刷新 token / 登出跳转 / 错误提示」抽成具名导出给它复用。
// 这里【只新增导出，不改动】下面现有的请求/响应拦截器，
// 门户既有的「主动预刷新 token（tokenTimeOut 判断）+ 401/405 登出」行为保持原样。

// token 刷新并发去重：同一时刻多处触发刷新时，只真正刷新一次，其余排队等结果
let pending;
let pendingList = [];
export function refreshTokenPromise() {
  return new Promise((resolve) => {
    pendingList.push(resolve);
    if (pending) {
      return;
    }
    pending = true;
    store.dispatch('TokenRefresh').then(() => {
      pending = false;
      const waitList = pendingList;
      pendingList = [];
      waitList.forEach(cb => cb());
    }).catch(() => {
      // 刷新失败也要放行等待队列，避免调用方永远挂起
      pending = false;
      const waitList = pendingList;
      pendingList = [];
      waitList.forEach(cb => cb());
    });
  });
}

// 登出并跳转登录页：复刻门户响应拦截器中 401/405 的既有内联逻辑，供 sseRequest 复用
export function logoutAndRedirect() {
  store.commit('LOGINOUT');
  Cookies.remove('loginName', { path: '/' });
  Cookies.remove('token', { path: '/' });
  Cookies.remove('tokenTimeOut', { path: '/' });
  Cookies.remove('langCode', { path: '/' });
  if (router.currentRoute.path !== '/login') {
    router.replace({ path: '/login' });
  }
}

// 统一错误提示，与拦截器里的 vm.$message.error 表现一致
export function showErrorMessage(msg) {
  const vm = new Vue();
  vm.$message.error(msg || '服务异常');
}
// ============ 具名导出结束 ============

// 请求拦截器
axios.interceptors.request.use(
  async (req) => {
    req.headers.clientToken = 'Basic YW5kcm9pZDphbmRyb2lk';
    req.headers.Authorization = Cookies.get('token') || '';
    req.headers['x-language-header'] = Cookies.get('langCode') || '';
    // 账号登录、微信登录、绑定用户、接口都需要再head带version
    const allowedUrls = [
      // 账号登录、微信登录、绑定用户、接口都需要再head带version
      apis.Login,
      apis.WechatLogin,
      apis.BindUser,
      // 运行记录年月季周日 导出
      apis.portalDeviceReportDailyPage,
      apis.portalDeviceReportSummaryPage,
      apis.portalDeviceReportDailyExport,
      apis.portalDeviceReportSummaryExport
    ];

    if (allowedUrls.includes(req.url)) {
      req.headers.version = 2;
    }
    req.headers.hostIp = localStorage.hostIp || '192.168.11.127'; // 张鹏
    // req.headers.hostIp = localStorage.hostIp || '192.168.11.130'; // 阿康
    // req.headers.hostIp = localStorage.hostIp || '192.168.11.132'; // 呆萌

    // 刷新token
    const now = Number(moment(Date.now()).format('X'));
    const isNotRefresh = req.url !== '/base/token/refresh';
    if (Cookies.get('token') && Cookies.get('tokenTimeOut') && now >= Cookies.get('tokenTimeOut') && isNotRefresh) {
      await store.dispatch('TokenRefresh');
      req.headers.Authorization = Cookies.get('token') || '';
    }
    return req;
  },
  err => Promise.reject(err)
);
// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    if (res.data && res.data.code === 0) {
      return res;
    }
    // 408是微信登录跳转绑定
    if (res.data && res.data.code === 408) {
      return res;
    }
    // 鲁班通上传
    if (res.data && res.data.msg === '操作成功') {
      return res;
    }
    if (res.data && res.data.code) {
      // 401token错误  405token已经完全过期
      if (res.data.code === 401 || res.data.code === 405) {
        store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
        Cookies.remove('langCode', { path: '/' });
        if (router.currentRoute.path !== '/login') {
          router.replace({ path: '/login' });
        }
        return Promise.reject(res.data);
      }
      const vm = new Vue();
      vm.$message.error(res.data.msg || '服务异常');
      return Promise.reject(res.data);
    }
    return res;
  },
  err => Promise.reject(err.response)
);
export default axios;
